<div class="tile-progress bg-white text-left col-lg-12">
  <div class="col-lg-6">
    <label>Select Account</label>
    <ng-select [items]="accounts" (change)="getLabelConfigByAccountId()" name="accounts" bindLabel="accountName"
      [clearable]="true" [searchable]="true" bindValue="accountId" [(ngModel)]="accountId" placeholder="Select account">
    </ng-select>
  </div>
  <div class="col-lg-6">
    <label>Select Account</label>
    <ng-select [items]="providers" (change)="getLabelConfigByProviderId()" name="providers" bindLabel="name"
      [clearable]="true" [searchable]="true" bindValue="id" [(ngModel)]="providerId" placeholder="Select provider">
    </ng-select>
  </div>
</div>

<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="background: white;padding: 0px;">
  <div *ngIf="(accountId==0 || accountId == null) && (providerId == 0 || providerId == null)" class="text-center">
    <label>Please select Account/Service Provider to continue.</label>
  </div>
  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="padding-left:0px;padding-right:0px"
    *ngIf="accountId!=null && accountId>0">
    <div class="card-header">
      Account Label Configuration
    </div>
    <div class="content-body padding-top-20 padding-bottom-20" style="padding-bottom: 0px !important;">
      <div class="row">
        <table class="table table-bordered">
          <tr>
            <th>Label Name</th>
            <th>Label Value</th>
          </tr>
          <tr>
            <td>Operator</td>
            <td><input type="text" [(ngModel)]="labelConfig.ROLE_OPERATOR" class="form-control"></td>
          </tr>
          <tr>
            <td>Screenin Center Manager</td>
            <td><input type="text" [(ngModel)]="labelConfig.ROLE_CLUSTER_LEAD" class="form-control"></td>
          </tr>
          <tr>
            <td>Account Admin</td>
            <td><input type="text" [(ngModel)]="labelConfig.ROLE_PROGRAM_LEAD" class="form-control"></td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 " style="padding-left:0px;padding-right:0px"
    *ngIf="providerId!=null && providerId>0">
    <div class="card-header">
      Provider Label Configuration
    </div>
    <div class="content-body padding-top-20 padding-bottom-20" style="padding-bottom: 0px !important;">
      <div class="row">
        <table class="table table-bordered">
          <tr>
            <th>Label Name</th>
            <th>Label Value</th>
          </tr>
          <tr>
            <td>Expert</td>
            <td><input type="text" [(ngModel)]="labelConfig.ROLE_OPTHALMOLOGY_EXPERT" class="form-control"></td>
          </tr>
          <tr>
            <td>Reading Center Manager</td>
            <td><input type="text" [(ngModel)]="labelConfig.ROLE_OPTHALMOLOGY_SUPERVISOR" class="form-control"></td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" *ngIf="accountId > 0 || providerId > 0">
    <div class="col-xs-12 text-center mBottom15">
      <button style="margin-right: 5px;" class="btn btn-sm btn-success marginLR5" (click)="saveLabelConfig()">
        <i class="fa fa-fw fa-lg fa-check-circle"></i> Save</button>
  </div>
  </div>
</div>